export let RuntimeEnvironment = /*#__PURE__*/function (RuntimeEnvironment) {
  RuntimeEnvironment["PRODUCTION"] = "production";
  RuntimeEnvironment["DEVELOPMENT"] = "development";
  RuntimeEnvironment["BOT"] = "bot";
  RuntimeEnvironment["INVALID_USER_AGENT"] = "invalid_useragent";
  RuntimeEnvironment["SLED"] = "sled";
  RuntimeEnvironment["SERVER"] = "sled";
  return RuntimeEnvironment;
}({});
export function calculateEnvironment() {
  if (typeof window === 'undefined') {
    return RuntimeEnvironment.SERVER;
  }
  const {
    hostname
  } = window.location;
  const {
    userAgent
  } = window.navigator;
  const {
    cookie
  } = window.document;

  // https://github.com/wix-private/sled/blob/c07286aac964a5acc4a1cb1e8c213c3b1fc0bf5d/packages/sled-test-runner/src/jest-runtime/lib/sled-global.ts#L134
  const isSled = /(^|;)\s*automation\s*=\s*sled:/.test(cookie);
  const isLocalhost = /localhost|127\.0\.0\.1|::1|\.local|local\.wix\.com|^$/i.test(hostname);
  const isBot = /Googlebot|AdsBot-Google-Mobile|bingbot|BingPreview|facebookexternalhit|Baiduspider|YandexBot/i.test(userAgent);
  const isNotValidUserAgent = /BonEcho|NewsGator|SeaMonkey|iTunes|Epiphany|Konqueror|Sleipnir|IceWeasel/i.test(userAgent);
  switch (true) {
    case process.env.NODE_ENV === 'development' || isLocalhost:
      return RuntimeEnvironment.DEVELOPMENT;
    case isBot:
      return RuntimeEnvironment.BOT;
    case isNotValidUserAgent:
      return RuntimeEnvironment.INVALID_USER_AGENT;
    case isSled:
      return RuntimeEnvironment.SLED;
    default:
      return RuntimeEnvironment.PRODUCTION;
  }
}
//# sourceMappingURL=environment-utils.js.map